import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import { BaseIcon } from "../base-icon";
export var SmartPhoneIcon = function(_param) /*#__PURE__*/ {
    var color = _param.color, _size = _param.size, size = _size === void 0 ? 24 : _size, props = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    return _jsx(BaseIcon, _object_spread_props(_object_spread({}, props), {
        color: color,
        height: size,
        width: size,
        children: /*#__PURE__*/ _jsx("path", {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M5.5 1.5h13a.5.5 0 0 1 .5.5v20a.5.5 0 0 1-.5.5h-13A.5.5 0 0 1 5 22V2a.5.5 0 0 1 .5-.5Zm-2 .5a2 2 0 0 1 2-2h13a2 2 0 0 1 2 2v20a2 2 0 0 1-2 2h-13a2 2 0 0 1-2-2V2Zm5.25 16.5a.75.75 0 0 0 0 1.5h6.5a.75.75 0 0 0 0-1.5h-6.5Z",
            clipRule: "evenodd"
        })
    }));
};
